/* ILS — Feedback form (TASK-2318 / TASK-3089).

   Website-feedback form on /pages/feedback. The user writes a message, may
   leave an optional email, and may attach optional screenshots.

   Delivery (TASK-3089 — replaces the old Shopify {% form 'contact' %} +
   tmpfiles.org path):
     - The form submits as JSON to the ils-admin backend endpoint
       POST /api/feedback (URL from the section's data-feedback-endpoint).
     - The backend emails the feedback to the store owner via Resend (a
       DKIM/SPF-verified sender that reliably inboxes), with screenshots
       attached DIRECTLY to the email — permanent, no expiring link.
     - Why this replaced Shopify's contact form: that path mailed
       info@ilovesnacks.eu as a self-domain, unauthenticated send routed
       through Shopify's infra → Google Workspace silently filed it as Spam
       (DMARC p=none, so never bounced). And screenshots went to tmpfiles.org
       whose links died after ~60 min.

   Screenshots are read to base64 in the browser and posted inside the JSON
   body. Total raw payload is capped client-side (see MAX_TOTAL_BYTES) to stay
   under the backend body-parser and Resend's per-message size limits.
*/
(function () {
  var form = document.getElementById('ILSFeedbackForm');
  if (!form) return;
  var fileInput = document.getElementById('ILSFeedback-files');
  var fileList = document.getElementById('ILSFeedback-filelist');
  var fileStatus = document.getElementById('ILSFeedback-filestatus');
  var bodyInput = document.getElementById('ILSFeedback-message');
  var emailInput = document.getElementById('ILSFeedback-email');
  var submitBtn = document.getElementById('ILSFeedback-submit');
  var confirmModal = document.getElementById('ILSFeedback-confirm');
  if (!fileInput || !fileList || !bodyInput || !submitBtn) return;

  var _sectionEl = document.querySelector('[data-ils-feedback]');
  // Backend endpoint. The section ships the URL as a data-* attribute (inline
  // <script> is stripped by Shopify's OS 2.0 section render pipeline). Fallback
  // to the staging domain (same host the reviews proxy uses) if unset.
  var ENDPOINT = (_sectionEl && String(_sectionEl.getAttribute('data-feedback-endpoint') || '').trim())
    || 'https://alert-dedication-production.up.railway.app/api/feedback';

  // TASK-2597: the native file-picker "No file chosen" / "Choose files"
  // strings are browser-locale controlled and can't be translated. The
  // section hides the native input and renders a localized label-as-button
  // plus this status span; the localized strings ride in as data-* on the
  // input (per-locale values computed in Liquid). JS mirrors picked-file
  // state into the status span so it never falls back to English.
  var I18N_NOFILE = fileInput.getAttribute('data-i18n-nofile') || 'No file chosen';
  var I18N_SELECTED = fileInput.getAttribute('data-i18n-selected') || 'Files selected:';
  // TASK-2603 — remaining strings (aria/alerts/button states) localized via the
  // same data-* channel; {curly} placeholders filled by fbFmt at runtime.
  var I18N_REMOVE = fileInput.getAttribute('data-i18n-remove') || 'Remove {name}';
  var I18N_MAXFILES = fileInput.getAttribute('data-i18n-maxfiles') || 'Maximum {max} files.';
  var I18N_TOOBIG = fileInput.getAttribute('data-i18n-toobig') || '{name} exceeds {max} MB and was skipped.';
  var I18N_WRITEFIRST = fileInput.getAttribute('data-i18n-writefirst') || 'Please write your feedback before sending.';
  var I18N_SENDING = fileInput.getAttribute('data-i18n-sending') || 'Sending…';
  var I18N_COULDNOT = fileInput.getAttribute('data-i18n-couldnot') || 'Could not send: ';
  var I18N_UPLOADING = fileInput.getAttribute('data-i18n-uploading') || 'Uploading {i}/{n}…';
  var I18N_UPLOADFAIL = fileInput.getAttribute('data-i18n-uploadfail') || 'Screenshot upload failed: {error} — try again, remove the file, or submit without screenshots.';
  function fbFmt(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) { return (vars && vars[k] != null) ? vars[k] : ''; });
  }

  function updateFileStatus() {
    if (!fileStatus) return;
    var txt;
    if (picked.length === 0) {
      txt = I18N_NOFILE;
    } else if (picked.length === 1) {
      // Single file: show its real name (language-neutral, avoids plural rules).
      txt = picked[0].name;
    } else {
      txt = I18N_SELECTED + ' ' + picked.length;
    }
    fileStatus.textContent = txt;
    fileStatus.title = txt; // full text on hover when the span is ellipsised
  }

  // TASK-2325 Правка 4: default cap raised from 5 to 6. The section still
  // ships the value via data-max-files, this fallback only kicks in if
  // the attribute is somehow missing.
  var MAX_FILES = parseInt(fileInput.dataset.maxFiles || '6', 10);
  var MAX_MB = parseInt(fileInput.dataset.maxSizeMb || '10', 10);
  var MAX_BYTES = MAX_MB * 1024 * 1024;
  // TASK-3089 — total raw payload cap across all screenshots. Screenshots are
  // base64-encoded into the JSON body; 20 MB raw ≈ 27 MB encoded, which stays
  // under the backend's 40 MB parser and Resend's ~40 MB per-message limit.
  var MAX_TOTAL_MB = parseInt(fileInput.dataset.maxTotalMb || '20', 10);
  var MAX_TOTAL_BYTES = MAX_TOTAL_MB * 1024 * 1024;

  var picked = [];
  // TASK-2325 Правка 3: cache blob URLs so we can revoke them when a file
  // is removed or the list is re-rendered. Otherwise createObjectURL() leaks
  // memory (spec: URL lives until the document is unloaded or explicitly
  // revoked). Parallel array to `picked` — index matches.
  var previewUrls = [];

  function fmtMB(b) { return (b / 1024 / 1024).toFixed(2) + ' MB'; }
  function totalBytes() {
    var t = 0;
    for (var i = 0; i < picked.length; i++) t += picked[i].size;
    return t;
  }

  function revokePreviews() {
    for (var i = 0; i < previewUrls.length; i++) {
      if (previewUrls[i]) {
        try { URL.revokeObjectURL(previewUrls[i]); } catch (e) {}
      }
    }
    previewUrls = [];
  }

  function renderList() {
    // Always drop old blob URLs before rebuilding, otherwise removing one
    // file mid-list would leak every prior URL.
    revokePreviews();
    fileList.innerHTML = '';
    picked.forEach(function (f, i) {
      var row = document.createElement('div');
      row.className = 'ils-feedback__filerow';

      // Local visual preview using URL.createObjectURL(). Works for any
      // image the browser can decode (jpeg/png/webp/heic where supported).
      // The <img> alt intentionally uses the filename so screen readers
      // still hear which upload this thumbnail represents.
      var url = URL.createObjectURL(f);
      previewUrls[i] = url;
      var img = document.createElement('img');
      img.src = url;
      img.alt = f.name;
      img.loading = 'lazy';
      img.decoding = 'async';
      row.appendChild(img);

      var size = document.createElement('span');
      size.className = 'size';
      size.textContent = fmtMB(f.size);
      row.appendChild(size);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'ils-feedback__filerm';
      rm.setAttribute('aria-label', fbFmt(I18N_REMOVE, { name: f.name }));
      rm.textContent = '×';
      rm.addEventListener('click', function () {
        picked.splice(i, 1);
        renderList();
      });
      row.appendChild(rm);
      fileList.appendChild(row);
    });
    updateFileStatus();
  }

  fileInput.addEventListener('change', function (e) {
    var added = Array.prototype.slice.call(e.target.files || []);
    for (var i = 0; i < added.length; i++) {
      var f = added[i];
      if (picked.length >= MAX_FILES) { alert(fbFmt(I18N_MAXFILES, { max: MAX_FILES })); break; }
      if (f.size > MAX_BYTES) { alert(fbFmt(I18N_TOOBIG, { name: f.name, max: MAX_MB })); continue; }
      picked.push(f);
    }
    e.target.value = '';
    renderList();
  });

  function readAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () {
        // fr.result is a data URL "data:image/png;base64,AAAA…" — strip prefix.
        var s = String(fr.result || '');
        var i = s.indexOf('base64,');
        if (i < 0) { reject(new Error('reader did not produce base64')); return; }
        resolve(s.slice(i + 7));
      };
      fr.onerror = function () { reject(fr.error || new Error('read error')); };
      fr.readAsDataURL(file);
    });
  }

  // Reveal the success state without a Shopify page redirect (we no longer POST
  // to Shopify's contact form). Hide the form, show the localized "thanks"
  // partial, move focus + scroll it into view for accessibility.
  function showSuccess() {
    var ok = document.querySelector('[data-ils-fb-success]');
    if (ok) {
      ok.hidden = false;
      try { ok.focus(); } catch (e) {}
      try { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
    form.style.display = 'none';
  }

  var origLabel = submitBtn.textContent;

  function currentLocale() {
    var l = document.documentElement.getAttribute('lang') || '';
    return l.trim().slice(0, 20);
  }

  function beginSubmission() {
    if (!bodyInput.value || !bodyInput.value.trim()) {
      alert(I18N_WRITEFIRST);
      bodyInput.focus();
      return;
    }
    // TASK-3089 — enforce the total-size ceiling before we spend time reading
    // files. Rare in practice (real screenshots are small), but prevents an
    // oversized JSON body from being rejected by the backend parser.
    if (totalBytes() > MAX_TOTAL_BYTES) {
      alert(fbFmt(I18N_UPLOADFAIL, { error: 'total attachments exceed ' + MAX_TOTAL_MB + ' MB — remove some or send fewer' }));
      return;
    }

    submitBtn.disabled = true;

    var shots = [];
    var i = 0;

    function send() {
      submitBtn.textContent = I18N_SENDING;
      var hpEl = document.querySelector('[data-ils-fb-hp]');
      var subjEl = form.querySelector('input[name="contact[subject]"]');
      var payload = {
        message: bodyInput.value,
        email: emailInput ? (emailInput.value || '') : '',
        subject: subjEl ? (subjEl.value || '') : '',
        locale: currentLocale(),
        pageUrl: document.referrer || '',
        hp: hpEl ? (hpEl.value || '') : '',
        screenshots: shots
      };
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        // no cookies needed; keeps the request CORS-simple/credential-free
        credentials: 'omit',
      }).then(function (res) {
        return res.json().then(function (j) { return { status: res.status, json: j }; },
          function () { return { status: res.status, json: null }; });
      }).then(function (r) {
        if (r.status === 200 && r.json && r.json.ok) {
          showSuccess();
          return;
        }
        var err = (r.json && r.json.error) ? r.json.error : ('HTTP ' + r.status);
        throw new Error(err);
      }).catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = origLabel;
        alert(I18N_COULDNOT + (err && err.message ? err.message : String(err)));
      });
    }

    function step() {
      if (i >= picked.length) { send(); return; }
      submitBtn.textContent = fbFmt(I18N_UPLOADING, { i: (i + 1), n: picked.length });
      readAsBase64(picked[i]).then(function (b64) {
        shots.push({
          filename: picked[i].name,
          mimeType: picked[i].type || 'application/octet-stream',
          dataBase64: b64
        });
        i++;
        step();
      }).catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = origLabel;
        alert(fbFmt(I18N_UPLOADFAIL, { error: (err && err.message ? err.message : String(err)) }));
      });
    }

    if (picked.length === 0) { send(); return; }
    step();
  }

  // ─── Confirmation popup (TASK-2319) ───────────────────────────────
  // The submit button opens a "Are you sure?" popup. Only after the
  // user clicks the confirm button do we actually run beginSubmission
  // (which reads screenshots + POSTs to the backend). Cancel/close keeps
  // the form state intact — nothing is reset — so the user can add
  // more content and try again.
  var lastFocused = null;

  function openConfirm() {
    if (!confirmModal) { beginSubmission(); return; }
    // Cheap client-side validation before we even open the modal.
    if (!bodyInput.value || !bodyInput.value.trim()) {
      alert(I18N_WRITEFIRST);
      bodyInput.focus();
      return;
    }
    lastFocused = document.activeElement;
    confirmModal.hidden = false;
    confirmModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var confirmBtn = confirmModal.querySelector('[data-ils-fb-confirm]');
    if (confirmBtn) setTimeout(function () { confirmBtn.focus(); }, 0);
  }

  function closeConfirm() {
    if (!confirmModal) return;
    confirmModal.hidden = true;
    confirmModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
    lastFocused = null;
  }

  if (confirmModal) {
    confirmModal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-ils-fb-cancel]')) {
        e.preventDefault();
        closeConfirm();
        return;
      }
      if (t.closest('[data-ils-fb-confirm]')) {
        e.preventDefault();
        closeConfirm();
        beginSubmission();
        return;
      }
      // Backdrop click (target is the overlay itself) also cancels —
      // form state is preserved by design.
      if (t === confirmModal) {
        e.preventDefault();
        closeConfirm();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!confirmModal || confirmModal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        closeConfirm();
      }
    }, true);
  }

  // Button is type="button" — a click never triggers the browser's own
  // form submission and so cannot be shadowed by a persistence library
  // that might otherwise call form.submit() on the same click and race
  // our async upload. We always own the flow.
  submitBtn.addEventListener('click', openConfirm);

  // Belt-and-braces: also intercept a raw submit event (e.g. an Enter
  // press inside a text field) and route it through the confirm flow.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    openConfirm();
  });
})();
